enum BrokerStatusEnum {
    Application = 'APPLICATION',
    Quote = 'QUOTE',
    Rejected = 'REJECTED',
}

export default BrokerStatusEnum;
